/**
 * guardian-address-toggle.ts
 *
 * Shared "guardian address is the same as the student's" checkbox behaviour for the
 * scholarship application create forms. Used by all three portals (User, School, Org) —
 * a single implementation avoids re-implementing the same hide/show logic per area.
 *
 * - Hides the guardian address fieldset (`[data-guardian-address-fields]`) when the
 *   checkbox (`[data-guardian-address-toggle]`) is checked, shows it when unchecked.
 * - The actual "copy student address into guardian address" logic happens server-side
 *   (GuardianAddressResolver in Core) — this script is purely a display convenience so
 *   the fields aren't shown/required when the checkbox is used.
 */

function getToggle(): HTMLInputElement | null {
  return document.querySelector('[data-guardian-address-toggle]');
}

function getFieldsContainer(): HTMLElement | null {
  return document.querySelector('[data-guardian-address-fields]');
}

function applyVisibility(toggle: HTMLInputElement, fields: HTMLElement): void {
  fields.classList.toggle('d-none', toggle.checked);
}

/**
 * Initialises the guardian-address-same-as-student toggle behaviour.
 * No-ops immediately when the toggle checkbox is absent, so this function is safe
 * to call on every page load.
 */
export function initGuardianAddressToggle(): void {
  const toggle = getToggle();
  const fields = getFieldsContainer();
  if (!toggle || !fields) return;

  applyVisibility(toggle, fields);
  toggle.addEventListener('change', () => applyVisibility(toggle, fields));
}
